module.exports = __webpack_public_path__ + "static/media/product6.b5d27a19.jpg";